import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './onboarding/onboardingStyles.css'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { LanguageProvider } from './contexts/LanguageContext.jsx'
import { HashRouter } from 'react-router-dom'
import { installConsoleCapture } from './utils/consoleCapture.js'
import { installAppBackHistory } from './hooks/appBackHistory.js'

installConsoleCapture({ max: 400 })
installAppBackHistory()

// After a deploy, a new service worker can claim this tab while the document
// still points at deleted hashed JS. Reload once so HTML and assets match.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  let reloadingAfterSwClaim = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadingAfterSwClaim) return
    reloadingAfterSwClaim = true
    window.location.reload()
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <LanguageProvider>
        <HashRouter>
          <App />
        </HashRouter>
      </LanguageProvider>
    </AuthProvider>
  </StrictMode>
)